import { SIGN_IN_EN_H5_SOURCE_MAP, SIGN_IN_EN_WEB_SOURCE_MAP } from "./const";
export function resolveBaseUrl(baseUrl, url = getCurrentLocation()) {
    if (!isTestPageUrl(url))
        return baseUrl;
    const parsed = new URL(baseUrl);
    parsed.hostname = `test${parsed.hostname}`;
    return parsed.toString().replace(/\/$/, "");
}
function getCurrentLocation() {
    if (typeof window === "undefined")
        return undefined;
    return window.location;
}
function isTestPageUrl(url) {
    return getHostname(url).toLowerCase().startsWith("test");
}
function getHostname(url) {
    if (!url)
        return "";
    if (url instanceof URL)
        return url.hostname;
    if (typeof url !== "string")
        return url.hostname;
    try {
        return new URL(url).hostname;
    }
    catch (_a) {
        return url;
    }
}
export const isMobile = () => {
    if (typeof navigator === "undefined")
        return false;
    return /iphone|ipod|ipad|android|mobile|blackberry|iemobile|opera mini|mobi/i.test(navigator.userAgent.toLowerCase());
};
export const resolveSource = (configuredSource) => {
    var _a;
    if (configuredSource)
        return configuredSource;
    if (typeof window === "undefined")
        return "";
    const map = isMobile() ? SIGN_IN_EN_H5_SOURCE_MAP : SIGN_IN_EN_WEB_SOURCE_MAP;
    const host = window.location.hostname;
    const realHost = host === null || host === void 0 ? void 0 : host.replace(/^test/, "");
    return (_a = map[realHost]) !== null && _a !== void 0 ? _a : "";
};
export const getUrlParam = (href) => {
    if (!href)
        return null;
    return new URL(href).searchParams.get("url");
};
export const buildProfileCompleteUrl = (userCenterUrl, locale, returnUrl) => {
    const url = new URL(`/${locale}/profile-complete`, userCenterUrl);
    if (returnUrl)
        url.searchParams.set("url", returnUrl);
    return url.href;
};
//# sourceMappingURL=utils.js.map